import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from '@godaddy/react-mintl';
import Link from '@ux/link';

const QuickLinks = ({ urls, appEid }) => {
  const { formatMessage } = useIntl();

  const pageEid = appEid.extend('quick_links');

  const messages = {
    controlPanelHeading:
      formatMessage({ id: 'Shared:AccountTray:QuickLinks:ControlPanelLinks:Heading' }),
    manageDomains:
      formatMessage({ id: 'Shared:AccountTray:QuickLinks:ControlPanelLinks:ManageDomains' }),
    manageWebsiteBuilder:
      formatMessage({ id: 'Shared:AccountTray:QuickLinks:ControlPanelLinks:ManageWebsiteBuilder' }),
    manageHosting:
      formatMessage({ id: 'Shared:AccountTray:QuickLinks:ControlPanelLinks:ManageHosting' }),
    manageSSLCerts:
      formatMessage({ id: 'Shared:AccountTray:QuickLinks:ControlPanelLinks:ManageSslCertificates' }),
    manageEmail:
      formatMessage({ id: 'Shared:AccountTray:QuickLinks:ControlPanelLinks:ManageEmail' })
  };

  return (
    <div className='account-info-section'>
      <div className='account-info-title'>
        <span>{ messages.controlPanelHeading }</span>
      </div>
      <Link
        className='customer-link-component'
        href={ urls.manageDomains.href }
        data-eid={ pageEid('manage_domains.link.click') }
        aria-label={ messages.manageDomains }>
        <span>{ messages.manageDomains }</span>
      </Link>
      <Link
        className='customer-link-component'
        href={ urls.products.href }
        data-eid={ pageEid.extend('products.link.click') }
        aria-label={ messages.manageWebsiteBuilder }>
        <span>{ messages.manageWebsiteBuilder }</span>
      </Link>
      <Link
        className='customer-link-component'
        href={ urls.manageHosting.href }
        data-eid={ pageEid.extend('manage_hosting.link.click') }
        aria-label={ messages.manageHosting }>
        <span>{ messages.manageHosting }</span>
      </Link>
      <Link
        className='customer-link-component'
        href={ urls.bigthree.ssl.href }
        data-eid={ pageEid.extend('manage_ssl.link.click') }
        aria-label={ messages.manageSSLCerts }>
        <span>{ messages.manageSSLCerts }</span>
      </Link>
      <Link
        className='customer-link-component'
        href={ urls.bigthree.email.href }
        data-eid={ pageEid.extend('manage_email.link.click') }
        aria-label={ messages.manageEmail }>
        <span>{ messages.manageEmail }</span>
      </Link>
    </div>
  );
};

QuickLinks.propTypes = {
  urls: PropTypes.object.isRequired,
  appEid: PropTypes.func
};

export default QuickLinks;
